var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6985 15.7431C17.8795 15.7423 17.0924 16.0602 16.5037 16.6295L10.4426 13.5989C10.4426 13.4723 10.468 13.3415 10.468 13.2106C10.468 13.0798 10.468 12.9489 10.4426 12.8223L16.5037 9.7918C17.588 10.835 19.2568 10.9709 20.4955 10.1167C21.7342 9.26256 22.2005 7.65448 21.6109 6.27015C21.0213 4.88583 19.5387 4.10783 18.0645 4.40918C16.5903 4.71052 15.532 6.00792 15.5329 7.51258C15.5329 7.64342 15.5329 7.77427 15.5582 7.90089L9.49718 10.9314C8.24931 9.72865 6.26624 9.75298 5.04825 10.986C3.83027 12.219 3.83027 14.2022 5.04825 15.4353C6.26624 16.6683 8.24931 16.6926 9.49718 15.4899L15.5582 18.5204C15.5582 18.647 15.5329 18.7778 15.5329 18.9087C15.5329 20.657 16.9502 22.0743 18.6985 22.0743C20.4468 22.0743 21.8641 20.657 21.8641 18.9087C21.8641 17.1604 20.4468 15.7431 18.6985 15.7431Z",
    fill: "#718193"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.08ac3fae1d2a3575ff170f44bd5e00c6.svg";
export { ForwardRef as ReactComponent };